module.exports = __webpack_public_path__ + "img/bespoke123_32.4ef1a50f.jpg";